import React, { Component } from "react";
import Helmet from "react-helmet";
import About from "../components/About/About";
import config from "../../data/SiteConfig";
import Header from "../components/Header/Header";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import HeaderPage from "../components/Header/HeaderPage";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer/Footer";
import ToTopButton from "../components/ToTopButton/ToTopButton";

import picture from "../components/About/img/about.jpg";

class AboutPage extends Component {
  render() {
    const { slug } = this.props.pathContext;
    const postNode = {
        "frontmatter": {
            "title": "A propos d'Integral Service",
            "description":  "Integral Service est une agence Web Lyonnaise spécialisée dans les technologies de l'internet. Notre coeur de métier est de réaliser des applications Web innovantes pour répondre aux besoins métiers de nos clients.",
            "cover": picture
        }
    };

    let title = "A propos d'Integral Service";
    let description = "Nous vous accompagnons dans vos projets Web";
    let goto = "En savoir plus";

    return (
      <div className="about" id="outer-container">
        <Helmet title={title} />
        <SEO postPath={slug} postNode={postNode} postSEO />
        <Menu/>
            <div id="page-wrap">
              <main id="fh5co-about">
                <Header />
                <HeaderPage title={title} description={description}  picture={picture} />
                <About />
              </main>
              <Footer/>
              <ToTopButton/>
            </div>
      </div>
    );
  }
}

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/about.jsx